import React from 'react';
import './BaseModal.css';

const BaseModal = ({
  show,
  title,
  onClose,
  onConfirm,
  onSecondaryAction,
  primaryActionLabel = 'Confirm',
  secondaryActionLabel = 'Cancel',
  children,
}) => {
  if (!show) return null; // Ensure the modal doesn't render when `show` is false

  return (
    <div className="modal-backdrop">
      <div className="modal-content">
        {/* Header */}
        {title && (
          <div className="modal-header">
            <h3>{title}</h3>
            <button className="close-button" onClick={onClose}>
              &times;
            </button>
          </div>
        )}

        {/* Body */}
        <div className="modal-body">{children}</div>

        {/* Footer */}
        <div className="modal-footer">
          {onSecondaryAction && (
            <button className="secondary-button" onClick={onSecondaryAction}>
              {secondaryActionLabel}
            </button>
          )}
          {onConfirm && (
            <button className="primary-button" onClick={onConfirm}>
              {primaryActionLabel}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default BaseModal;
